import React, { useCallback, useEffect, useState } from 'react';
import { Input, Checkbox, Button } from 'antd';
import { NoData } from '@components';

const SelectAll = 'Select All';

function CountryFilter({
  selectedKeys,
  allCountries = [],
  onSelectedKeyChange,
  onCancel = () => {},
  visible,
}) {
  const [keyword, setKeyword] = useState('');
  const [options, setOptions] = useState([]);
  const [selectAll, setSelectAll] = useState(true);
  const [innerSelectedKeys, setInnerSelectedKeys] = useState([]);

  useEffect(() => {
    setKeyword('');
    setOptions(allCountries);
    setInnerSelectedKeys(allCountries);
  }, [allCountries]);

  useEffect(() => {
    setInnerSelectedKeys([...selectedKeys]);
  }, [JSON.stringify(selectedKeys)]);

  // const onCheckboxChange = (value) => {
  //   if (typeof onSelectedKeyChange !== 'function') {
  //     return console.error('missing argument onSelectedKeyChange');
  //   }
  //   onSelectedKeyChange(value);
  // };
  const onCheckboxChange = (e) => {
    const { checked, value } = e.target;
    if (checked && !innerSelectedKeys.includes(value)) {
      setInnerSelectedKeys([...innerSelectedKeys, value]);
    } else {
      setInnerSelectedKeys(innerSelectedKeys.filter((i) => i !== value));
    }
  };
  const onKeywordChange = useCallback(
    (e) => {
      const value = e.target.value;
      setKeyword(value);
      if (value) {
        setOptions(
          allCountries.filter((i) =>
            i?.toLowerCase().includes(value.toLowerCase()),
          ),
        );
      } else {
        setOptions(allCountries);
      }
    },
    [allCountries],
  );

  useEffect(() => {
    if (visible === false) {
      onKeywordChange({ target: { value: '' } });
      setInnerSelectedKeys([...selectedKeys]);
    }
  }, [visible, selectedKeys]);

  const onSelectAllChange = (e) => {
    const checked = e.target.checked;

    setInnerSelectedKeys(checked ? allCountries : []);
  };

  const onReset = () => {
    onSelectAllChange({ target: { checked: true } });
    onSelectedKeyChange([...allCountries]);
    setOptions([...allCountries]);
    setKeyword('');
  };

  const onOK = () => {
    if (typeof onSelectedKeyChange !== 'function') {
      return console.error('missing argument onSelectedKeyChange');
    }
    const filteredKeys = innerSelectedKeys.filter((key) =>
      options.includes(key),
    );
    onSelectedKeyChange([...filteredKeys]);
  };

  useEffect(() => {
    if (
      innerSelectedKeys?.length === allCountries.length &&
      allCountries.length > 0
    ) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [innerSelectedKeys, allCountries]);

  return (
    <div className="headcount-sales-filter">
      <Input
        prefix={<span className="appkiticon icon-search-outline" />}
        placeholder="Search"
        value={keyword}
        onChange={onKeywordChange}
        style={{
          marginBottom: 8,
        }}
      />
      {options.length ? (
        <>
          <div className="filter-list">
            <div className="filter-list-item" hidden={keyword ? true : ''}>
              <Checkbox
                value={SelectAll}
                key={SelectAll}
                checked={selectAll}
                onChange={onSelectAllChange}
              >
                Select All
              </Checkbox>
            </div>
            <ul>
              {options.map((i) => (
                <li key={i} title={i}>
                  <Checkbox
                    value={i}
                    onChange={onCheckboxChange}
                    checked={innerSelectedKeys.includes(i)}
                  >
                    {i === true ? 'Yes' : i === false ? 'No' : i}
                  </Checkbox>
                </li>
              ))}
            </ul>
          </div>
          <div className="buttons-wrapper">
            <Button type="default" onClick={onReset}>
              Reset
            </Button>
            <Button type="default" onClick={onCancel}>
              Cancel
            </Button>
            <Button type="primary" onClick={onOK}>
              ok
            </Button>
          </div>
        </>
      ) : (
        <NoData />
      )}
    </div>
  );
}

export default CountryFilter;
